<template>
  <div class="news">
    <div class="m-top-box">
		<Nav/>
		<div class="m-layout-center">      
			<h2>新闻中心</h2>
		</div>
    </div>
	<div class="m-layout-center">		
		<router-view></router-view>
	</div>
  </div>
</template>
<style scoped lang="scss">
	.m-top-box{ 
		width: 100%; 
		padding-top: 10px;
		height: 390px; 
		background: url(https://alicdn.jinhui365.com/res/cms/activity/cloudcode/images/xwzx_banner.png) no-repeat center top;
		background-size:cover; 
		h2 {
			color: #fff;
			font-size: 68px;
			font-weight: 500;
			text-align: center;
			height: 100px;
			line-height: 100px;
			margin-top: 166px;
			margin-bottom: 60px;
		}
	}
 </style>
<script>
import Nav from '@/components/Nav.vue';
export default {
	name:'news',
	components: {
		Nav
	}
}
</script>